<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="32%">
        <el-form ref="form" :model="form" :rules="rules" label-width="152px">
            <el-form-item label="商品分类名称:" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="请选择测评一级类型:" prop="type">
                <el-radio v-model="form.type" :label="1">产品体验</el-radio>
                <el-radio v-model="form.type" :label="2">探店体验</el-radio>
            </el-form-item>
            <el-row type="flex" justify="end">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" :loading="submitting" @click="onSubmit">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { createClassify } from "@/api/basic"

export default {
    data: () => ({
        rules: {
            name: [
                { required: true, message: "请输入商品分类名称", trigger: 'blur' }
            ]
        },
        form: {
            name: '',
            type: 1
        },
        submitting: false
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        name: '',
                        type: 1
                    }
                },
                edit: () => {
                    const { id, name, type } = this.editData
                    this.form = {
                        id, name, type
                    }
                }
            }

            handlers[this.type]()
        },
        onSubmit() {
            const { form } = this

            const handlers = {
                add: () => {
                    this.$refs["form"].validate(async valid => {
                        if (valid) {
                            this.submitting = true
                            try {
                                await createClassify(form)
                                this.$message({
                                    message: '新增成功!',
                                    type: 'success'
                                });
                                this.$emit('onUpdate')
                                this.trunOff()

                            } catch {
                                this.$message.error('新增失败!')
                            } finally {
                                this.submitting = false
                            }
                        }
                    })
                },
                edit: () => {
                    this.$refs["form"].validate(async valid => {
                        if (valid) {
                            this.submitting = true
                            try {
                                await createClassify(form)
                                this.$message({
                                    message: '编辑成功!',
                                    type: 'success'
                                });
                                this.$emit('onUpdate')
                                this.trunOff()
                            } catch {
                                this.$message.error('编辑失败!')
                            } finally {
                                this.submitting = false
                            }
                        }
                    })
                }
            }

            handlers[this.type]()
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>